import { useDelayedVisibility } from 'hooks/useDelayedVisibility';
import { useSelector } from 'store';
import { useGetInvoiceTotalsQuery } from 'store/api/invoices';

// buttonsDisabled spans the mutation itself, isFetching spans the totals refetch its
// cache invalidation triggers — together they cover the whole recalculation window.
// isAlsoRecalculating lets a region extend the window with its own refetch signal
// (e.g. the matter summary that carries the timecard/expense rows).
export const useInvoiceRecalculating = (invoiceId: number, isAlsoRecalculating = false): boolean => {
    const { buttonsDisabled } = useSelector((state) => state.buttons);
    const { isFetching } = useGetInvoiceTotalsQuery(invoiceId, {
        selectFromResult: ({ isFetching }) => ({ isFetching }),
    });

    return useDelayedVisibility(buttonsDisabled || isFetching || isAlsoRecalculating);
};
